import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: 236,
      margin: 'auto',
    },
    image: {
      userSelect: 'none',
    },
    area: {
      cursor: 'pointer',
    },
  }),
);

export default useStyles;
